import { useTranslation } from 'react-i18next'
import { OpspbCancelRequest } from '@itsrever/rever-api'
import { cancelProcess } from '@/api/ops-api'
import { useProcessAction } from './use-process-action'

export function useCancelProcess() {
  const { t } = useTranslation()
  return useProcessAction({
    action: (request: OpspbCancelRequest) =>
      cancelProcess({ opspbCancelRequest: request }),
    errorText: t('review_toast.error'),
    reloadAfterMs: 1000
  })
}
